import { Box, Button, Flex, Modal, Text, TextInput } from "@mantine/core"
import { useContext, useMemo, useState } from "react"
import CustomersList from "./CustomersList"
import FilterBar from "./FilterBar"
import { DARK_GREY_TEXT, LIGHT_GREY_BG, PRIMARY_BLUE } from "../../../constants/colors"
import { IconSearch, IconCheck, IconX } from "@tabler/icons"
import SingleCustomerContext from "../Customer-Context/SingleCustomerContext"
import { useNavigate } from "react-router-dom"

const ModalCustomers = ( { opened, close } : { opened: boolean, close: any }) => {

  const { 
    account,
    accountName,
    setAccountName,
    setAccount,
    setTextQuery, 
    customersItems, 
    totalCustomersCount,
    setCustomerIds,
    customerIds,
    activeFilters,
    setIsSegmentSelection,
    isReadyForSelect,
    textQuery,
    setViewType,
    isLoading
  } = 
    useContext(SingleCustomerContext)

  const [selectedValues, setSelectedValues] = useState<string[]>([]);
  const [chosenCustomerId, setChosenCustomerId] = useState<string>('')

  const customersCount = useMemo(() =>
  {
    if(activeFilters.length === 0) {
      return selectedValues.length
    }
    if(selectedValues.length > 0 && activeFilters.length > 0) {
      return selectedValues.length
    }
    return customersItems?.length

  }, [customersItems, selectedValues, activeFilters])

  const disableSelectButton: boolean = useMemo(() =>
  {
    if(activeFilters.length === 0 && selectedValues.length === 0) {
      return true
    }
    return false  
  
  }, [customersItems, selectedValues, activeFilters])

  return (
    <Modal 
      size={960} 
      opened={opened} 
      onClose={close} 
      withCloseButton={false}
      title={<Box
        w={960}
        bg={LIGHT_GREY_BG}
        px={24} 
        pt={0} 
        mt={24}
        pb={10}
        style={{ position: 'relative' }}
      >
        <Flex align="center" justify="space-between" w="100%">
          <Text 
            fz={20} 
            fw={600} 
            pb={4}>
            Select a 360 view
          </Text>
          <Flex
            onClick={close}
            style={{ cursor: 'pointer' }}
          >
            <IconX size={16} color={PRIMARY_BLUE} />
            <Text
              ml={4}
              fz={14} 
              fw={400} 
              color={PRIMARY_BLUE}>
              Close
            </Text>
          </Flex>
        </Flex>
        <Box w="100%" >
          <Text 
            h={18} 
            color={DARK_GREY_TEXT} 
            fz={14} 
            w="100%"
          >
             Select a customer to view its product requests and statuses  
          </Text>
        </Box>
      </Box>
      }
      centered
      styles={{
        body: {
          padding: 0,
          overflow: 'hidden'
        },
        content: {
          padding: 0,
          overflow: 'hidden'
        },
        header: {
          padding: 0,
          backgroundColor: LIGHT_GREY_BG
        }
      }}
    >
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        height: '100%',
        overflow: 'hidden'
      }}>
        <Box 
          h={166} 
          bg={LIGHT_GREY_BG}
          style={{
            position: 'absolute',
            top: -150,
            left: 0,
            right: 0,
            zIndex: 0
          }}
        />
        
        <Box>
          <Box pb={10} bg={LIGHT_GREY_BG} px={24}>
            <FilterBar/>
          </Box>

          <Box bg={LIGHT_GREY_BG} px={24} pb={10}>
            <TextInput
              value={account?.name || accountName}
              onChange={(e: any) => {
                setAccountName(e.target.value);
                setTextQuery(e.target.value)
              }}
              onFocus={() => {
                setAccountName('')
                setAccount(undefined)
              }}
              placeholder="Search customer"
              icon={<IconSearch size={16} color="#4F4F4F" />}
            />
          </Box>
          
          <Flex bg={LIGHT_GREY_BG} px={24} gap={4} pb={4}>
            <Text fz={14} fw={600} color={DARK_GREY_TEXT}>
              { (textQuery !== '' || activeFilters.length > 0)  ? customersItems?.length : totalCustomersCount}
            </Text>
            <Text fz={14} fw={400} color={DARK_GREY_TEXT}>
              of 
            </Text>
            <Text fz={14} fw={600} color={DARK_GREY_TEXT}>
              {  totalCustomersCount}
            </Text>
          </Flex>
          <Box px={24} mt={6}>
            <CustomersList 
              setChosenCustomerId={setChosenCustomerId}
              selectedValues={selectedValues}
              setSelectedValues={setSelectedValues}
              setAccountName={setAccountName}
              setTextQuery={setTextQuery}
            />
          </Box>
        </Box>

        <Flex 
          h={48}
          w="100%" 
          align="center"
          justify="space-between"
          px={24}
          bg={LIGHT_GREY_BG} 
        >
          {!isReadyForSelect ? <Box>
            <Text
              color="grey"
              fz={14.5}
            >
            Please narrow down your selection for better experience
            </Text>
          </Box> : 
            <Box></Box>}
          <Box>
            <Button 
              loading={isLoading}
              disabled={disableSelectButton || !isReadyForSelect}
              h={32}
              w={customersCount === 3000 ? 250 : 200}
              px={10}
              sx={{
                backgroundColor: PRIMARY_BLUE,
                color: '#fff',
                '&:hover': {
                  backgroundColor: "#5353D3 !important",
                },
              }}
              onClick={() => {
                if(selectedValues.length === 0) {
                  setViewType('segment')
                  setIsSegmentSelection(true)
                  const values = customersItems.map((customer: any) => customer._id)
                  setCustomerIds(values)
                } else {
                  if(selectedValues.length === 1){
                    setViewType('single')
                  }

                  else if(selectedValues.length > 1){
                    setViewType('multiple')

                  }

                  setCustomerIds(selectedValues)
                }
                close()
              }} 
            >
              {!isLoading && <Flex align="center" >
                <IconCheck size={16} />
                <Text fw={400} fz={14} ml={4}>
                  Select
                </Text>
                <Text fw={400} fz={14} ml={4}>
                  {customersCount}
                </Text>
                {customersCount === 3000 && <Text fw={400} ml={3}>
                  (Max)
                </Text>}
                <Text fw={400} fz={14} ml={4}>
                  Customers
                </Text>
              </Flex>}
            </Button>
          </Box>
        </Flex>
      </Box>
    </Modal>
  )
}

export default ModalCustomers